import { NavLink } from "react-router-dom";
import { useAppSelector } from "../../../../../redux/hooks";
import { getCatalog } from "../../../../../redux/selectors";
import styles from "./index.module.scss";

interface Card {
  image: string;
  title: string;
}

const data = [
  {
    id: 1,
    img: "https://emex.ru/static/images/miniBanners/tire.webp",
    title: "Шины",
  },
  {
    id: 2,
    img: "https://emex.ru/static/images/miniBanners/carDisk.webp",
    title: "Диски",
  },
  {
    id: 3,
    img: "https://emex.ru/static/images/miniBanners/carOil.webp",
    title: "Масло",
  },
];

const Related = () => {
  return (
    <div className={styles.related}>
      <div className="container">
        <h2 className="title">Сопутствующие товары</h2>
        <div className={styles.cards}>
          {data.map(({ id, img, title }) => (
            <Card key={id} image={img} title={title} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Card = ({ image, title }: Card) => (
  <div className={styles.card}>
    <NavLink to={"catalog/" + title}>
      <h3 className={styles.title}>{title}</h3>
      <img src={image} alt="skeleton" />
    </NavLink>
  </div>
);

export default Related;
